module.exports = __webpack_public_path__ + "static/media/4.b5756b96.png";